<script setup>
import { computed } from "vue";
import { useI18n } from "vue-i18n";

import { Link, usePage } from "@inertiajs/vue3";

const locale = computed(() => usePage().props.locale);

// Layout
import PublicLayout from "@/Layouts/PublicLayout.vue";
import ServiceFirst from "@/Components/ServiceFirst.vue";
import ServiceSecond from "@/Components/ServiceSecond.vue";
import ServiceThird from "@/Components/ServiceThird.vue";
import ServiceFourth from "@/Components/ServiceFourth.vue";
import ServiceFifth from "@/Components/ServiceFifth.vue";
import ServiceSix from "@/Components/ServiceSix.vue";
import ServiceSeven from "@/Components/ServiceSeven.vue";
import FloatingCta from "@/Components/FloatingCta.vue";

const { t } = useI18n();

const props = defineProps({
  page: Object,
  jobOffers: Object,
  blogArticles: {
    type: Array,
    required: true
  }
});
</script>

<template>
  <PublicLayout title="Zorgblik">
    <FloatingCta
      class="hidden lg:flex"
      :title="$t('Create an account without obligation')"
      link="#signup"
      :button-text="$t('Create account')"
    ></FloatingCta>

    <ServiceFirst />
    <ServiceSecond />
    <ServiceThird />
    <ServiceFourth />
    <ServiceFifth />
    <ServiceSix />
    <ServiceSeven />
    <!-- <AboutEight /> -->
  </PublicLayout>
</template>
